module.exports = __webpack_public_path__ + "static/Construction-Photo1-8c9dd8c22e3e365c48ef198ae9268d8e.png";